// Libraries
import { Icon } from '@chakra-ui/react';
// Theme
import { colors } from '@themeFoundations/colors';
// Types
import { EnvelopeIconPaths, EnvelopeIconProps, EnvelopeIconType, EnvelopeIconViewBox } from './EnvelopeIcon.type';

/**
 * Component that renders the Envelope Icon.
 * @param {IconProps} props - The IconProps for the EnvelopeIcon component.
 * @returns {ReactElement} The EnvelopeIcon component.
 */
export const EnvelopeIcon = (props: EnvelopeIconProps) => {
  const { iconType = EnvelopeIconType.DEFAULT, color = colors.base, ...rest } = props;
  const envelopeFill = iconType === EnvelopeIconType.CHECK ? colors.clearBase : colors.base;
  return (
    <Icon viewBox={EnvelopeIconViewBox[iconType]} color={color} id='envelope-icon' {...rest}>
      {iconType === EnvelopeIconType.CHECK ? (
        <>
          <path d={EnvelopeIconPaths[iconType]} fill={envelopeFill} />
          <path
            d='M34.0996 33.3125C34.0996 25.5488 40.348 19.25 48.0496 19.25C55.7512 19.25 61.9996 25.5488 61.9996 33.3125C61.9996 41.0762 55.7512 47.375 48.0496 47.375C40.348 47.375 34.0996 41.0762 34.0996 33.3125ZM54.5693 31.291C55.1796 30.6855 55.1796 29.6895 54.5693 29.084C53.9687 28.4688 52.9806 28.4688 52.3799 29.084L46.4996 35.0117L43.7193 32.209C43.1187 31.5938 42.1305 31.5938 41.5299 32.209C40.9196 32.8145 40.9196 33.8105 41.5299 34.416L45.4049 38.3223C46.0055 38.9375 46.9937 38.9375 47.5943 38.3223L54.5693 31.291Z'
            fill='currentColor'
          />
        </>
      ) : (
        <path d={EnvelopeIconPaths[iconType]} fill={envelopeFill} />
      )}
    </Icon>
  );
};
